import React, { useRef, useState, useEffect, useContext } from 'react';
import "./navbar.css"
import { Button } from 'primereact/button';
import { TieredMenu } from 'primereact/tieredmenu';
import 'primeicons/primeicons.css';
import { Sidebar } from 'primereact/sidebar';
import Logo from '../../assets/images/image.png';
import { Divider } from 'primereact/divider';
import BlackProfile from '../../assets/icons/black-profile.svg';
import Message from '../../assets/icons/message.svg';
import Bag from '../../assets/icons/bag.svg';
import Footer from '../footer/footer';
import Form from 'react-bootstrap/Form';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import Loadr from '../../components/loader/loader'
import CustomerContext from '../../contexts/CustomerContext';  // Import CustomerContext

// import { Button } from 'primereact/button';
//icon
import { ChangePass } from '../../utils/api'
import ProfileIcon from '../../assets/icons/profile.svg';
import NavContext from '../../contexts/NavContext';

const Navbar = () => {
  const toast = useRef(null);
  const menu = useRef(null);
  const [visibleRight, setVisibleRight] = useState(false);
  const [profile, setProfile] = useState(true);
  const [order, setOrder] = useState(false);
  const [comment, setComment] = useState(false);
  const [changePasswordDialog, setChangePasswordDialog] = useState(false);
  const [customerData, setCustomerData] = useState();
  const [password, setPassword] = useState('')
  const [oldPassword, setOldPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [validated, setValidated] = useState(false);
  const [loader, setLoader] = useState(false);
  const { customerInfo } = useContext(CustomerContext);  // Get customerInfo from context

  useEffect(() => {
    let customerDatares = window.localStorage.getItem('userInfo');
    if (customerDatares) {
      setCustomerData(JSON.parse(customerDatares));
    }
  }, []);
  const showError = (error) => {
    toast.current.show({ severity: 'error', detail: error.text, life: 3000 });
  }
  const showSuccess = (success) => {
    toast.current.show({ severity: 'success', detail: success.text, life: 3000 });
  }

  const { setNav } = useContext(NavContext);
  const changeNav = (name) => {
    setNav(name)
  };
  const gotoProfile = () => {
    setComment(false);
    setOrder(false);
    setProfile(true);
    changeNav('profile');
    setVisibleRight(false)
  };

  const gotoOrder = () => {
    setComment(false);
    setOrder(true);
    setProfile(false);
    changeNav('order');
    setVisibleRight(false)

  };

  const gotoComment = () => {
    setComment(true);
    setOrder(false);
    setProfile(false);
    changeNav('comment');
    setVisibleRight(false)

  };
  const submitPassword = async (event) => {
    event.preventDefault(); // Prevent the default form submission

    const form = event.currentTarget;
    if (form.checkValidity() === true) {
      event.stopPropagation();

      try {
        if (password === confirmPassword) {
          let pay = {
            customerID: customerData.customerID,
            oldPass: oldPassword,
            newPass: password
          }
          setLoader(true)
          let res = await ChangePass(pay)
          if (res.data.res === 'OK') {
            setChangePasswordDialog(false)
            setLoader(false)
            showSuccess({ text: res.data.resTp });
          } else {
            showError({ text: res.data.resTp })
            setLoader(false)
          }

        } else {
          setLoader(false)
          showError({ text: 'رمز عبور یکسان نیست.' });

        }
      } catch (error) {

      }

    }

    setValidated(true); // You may want to move this inside the if block, depending on your needs



  }
  const items = [
    {
      label: customerInfo ? `${customerInfo.fname} ${customerInfo.lname} خوش آمدید!`: 'خوش آمدید!',
      icon: 'pi pi-user',
    },
    {
      label: 'تغییر رمزعبور',
      icon: 'pi pi-lock',
      command: () => {
        setChangePasswordDialog(true)
      }
    },
    {
      label: 'خروج از حساب کاربری',
      icon: 'pi pi-sign-out',
      command: () => {
        localStorage.removeItem("userInfo");
        window.location.href = '/'
      }
    },
  ];

  return (
    <div>
      <Toast ref={toast} />
      <div className="navbar-card">
        <Button icon="pi pi-bars" className='btn-bar' onClick={() => setVisibleRight(true)} />
        <div></div>
        <Button className='btn-outline' onClick={(e) => menu.current.toggle(e)}>
          {customerInfo  ? customerInfo.fname + ' ' + customerInfo.lname : 'نام'}
          <img className='mr-4' src={ProfileIcon} alt="" />

        </Button>
      </div>
      <TieredMenu model={items} popup ref={menu} breakpoint="767px" />
      <Sidebar visible={visibleRight} onHide={() => setVisibleRight(false)} position="right" style={{ position: 'relative' }} >
        <div className='img-box mt-2'>
          <img src={Logo} alt="" width={120}/>
        </div>
        <Divider />
        <div className='menu-items '>
          <div className={`item ${profile ? 'active' : ''}`} onClick={gotoProfile}>
            <img className='ml-2' src={BlackProfile} alt="" />
            پروفایل من
          </div>
          <div className={`item ${order ? 'active' : ''}`} onClick={gotoOrder}>
            <img className='ml-2' src={Bag} alt="" />
            سفارشات من
          </div>
          <div className={`item ${comment ? 'active' : ''}`} onClick={gotoComment}>
            <img className='ml-2' src={Message} alt="" />
            نظرات من
          </div>
        </div>
        <Footer />
      </Sidebar>

      <Dialog header="ثبت رمزعبور ثابت" visible={changePasswordDialog} onHide={() => { if (!changePasswordDialog) return; setChangePasswordDialog(false); }}
        style={{ width: '400px' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}>
        <hr className='my-0' style={{ color: '#669d24  !important', borderWidth: '3px' }} />
        <Form className='row gx-5 mb-4 mt-3' noValidate validated={validated} onSubmit={submitPassword}>
          <Form.Group className="mb-3 col-12">
            <Form.Label>رمز قدیم</Form.Label>
            <Form.Control type="password" required value={oldPassword} onChange={(e) => setOldPassword(e.target.value)} />
            <Form.Control.Feedback type="invalid">
              لطفا رمزقدیم را وارد کنید
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3 col-12">
            <Form.Label>رمز جدید</Form.Label>
            <Form.Control type="password" required value={password} onChange={(e) => setPassword(e.target.value)} />
            <Form.Control.Feedback type="invalid">
              لطفا رمزجدید را وارد کنید
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="mb-3 col-12">
            <Form.Label>تکرار رمز جدید</Form.Label>
            <Form.Control type="password" required value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
            <Form.Control.Feedback type="invalid">
              لطفا رمز را تکرار کنید
            </Form.Control.Feedback>
          </Form.Group>
          <button disabled={loader} className='btn btn-primary mt-3 mx-auto d-flex align-items-center justify-content-center gap-2' style={{ width: '90%' }}> {loader && <Loadr />}ثبت</button>
        </Form>
      </Dialog>
    </div>
  );
}

export default Navbar;
